export default [
    {
        path: 'relatorio-solicitacoes',
        component: () => import(
            /* webpackChunkName: 'manutencao-relatorio-solicitacoes' */
            '@/views/manutencao/relatorio-solicitacoes/Index'
        ),
        redirect: 'relatorio-solicitacoes/index',
        children: [
            {
                name: 'manutencao-relatorio-solicitacoes-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'manutencao-relatorio-solicitacoes' */
                    '@/views/manutencao/relatorio-solicitacoes/List.vue'
                ),
            },
        ],
    },
]